import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Box, Button, Dialog, TextField, Typography, makeStyles, withStyles, Divider, IconButton } from '@material-ui/core';
import * as Yup from 'yup';
import { Formik } from 'formik';

const CssTextField = withStyles({
  root: {
    fontSize: 24,
    '& label': {
      fontSize: 14,
      color: '#697683',
      fontWeight: '400'
    },
    '& input': {
      fontSize: 14,
      fontWeight: '400',
      color: '#8F99A3',
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: '#697683',
      borderBottomWidth: 1.6,
    },
    "& .MuiInputBase-root.Mui-disabled:before": {
      borderBottom: '1.6px solid #697683'
    }
  },
})(TextField);

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    paddingTop: 26
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    background: 'transparent!important'
  },
  header: {
    color:" #697683",
    fontFamily: 'Spartan-bold',
    fontSize: 24,
    paddingLeft: 17,
    paddingBottom: 7,
    display: 'flex',
    alignItems: 'center'
  },
  helperText: {
    textAlign: 'right',
    marginRight: 0
  }
}));

function CreatorPickModal({
  experience,
  open,
  onClose,
  onSuccess,
  className,
  ...rest
}: any) {

  const classes = useStyles();

  return (
    <Dialog
      fullWidth={true}
      maxWidth={'sm'}
      onClose={onClose}
      open={open}
    >
      <div
        className={clsx(className)}
        {...rest}
      >
        <Box m={2} ml={4} mt={3}>
        <div className={classes.header}>Other...
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <img src={'/assets/icons/creatordashboard/project-modal-close.svg'} alt={'img'}/>
          </IconButton>
        ) : null}
      </div>              
      </Box>
        <Divider />
        <Box m={4}>
          <Typography
            variant="subtitle2"
            color="textSecondary"
          >
            We are always looking to improve the categories that our customers need. Please let us know what type of experience this should be called?
          </Typography>

          <Formik
            initialValues={{
              experience: experience,
              // category: category
            }}
            validationSchema={Yup.object().shape({
              experience: Yup.string().max(20).min(3).required(),
              // category: Yup.string().max(20).min(3).required(),
            })}
            onSubmit={async (values, {
              setStatus,
              setSubmitting
            }) => {
              try {
                setStatus({ success: true });
                setSubmitting(false);
                // enqueueSnackbar('New Participant Added', {
                //   variant: 'success'
                // });
                onSuccess({
                  experience: values.experience,
                  // category: values.category
                });
              } catch (err) {
                // setErrors({ submit: err.message });
                setStatus({ success: false });
                setSubmitting(false);
              }
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values
            }: any) => (
              <form
                onSubmit={handleSubmit}
                className={clsx(classes.root, className)}
                {...rest}
              >
                <CssTextField
                  error={Boolean(touched.experience && errors.experience)}
                  fullWidth
                  helperText={touched.experience && errors.experience}
                  label="What would you call this type of experience?"
                  name="experience"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.experience}
                />
                <Box mt={5} display='flex' justifyContent='flex-end'>
                  <Button
                    color="primary"
                    variant="contained"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    Submit
                </Button>
                </Box>
              </form>
            )}
          </Formik>
        </Box>
      </div>
    </Dialog>
  );
}

CreatorPickModal.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
  experience: PropTypes.string,
  open: PropTypes.bool.isRequired
};

CreatorPickModal.defaultProps = {
  onClose: () => { }
};

export default CreatorPickModal;
